import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'

import { focusVisible } from '@space-core/styles'
import styled from 'styled-components'

import ProgressMobile from '../mobileDefault'

import type { ProgressCardProps } from '../types'

const ProgressButton = styled.button<{ isCarousel?: boolean; isMobile?: boolean }>`
  background: 0;
  ${({ isCarousel, isMobile }) =>
    isCarousel &&
    `
    flex: none;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
    width: ${isMobile ? '85%' : '30.5%'};
    margin-right: var(--spacer-2);

    :first-child {
      margin-left: var(--spacer-2);
    }
  `}
  ${focusVisible}
`

const ProgressCardMobile = ({ product, handleClick, isCarousel }: ProgressCardProps) => {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.sm})`)

  return (
    <ProgressButton
      data-test='progress-btn'
      onClick={handleClick}
      isCarousel={isCarousel}
      isMobile={isMobile}
      className='_border-0 _p-0'
      aria-label='button'>
      <ProgressMobile product={product} />
    </ProgressButton>
  )
}

export default ProgressCardMobile
